import React from 'react';
import { Col, Row } from '../../../lib/utils';
import { Body3Bold, Body3Regular } from '../../../lib/font';
import { colors } from '../../../lib/colors';
import { PaymentOrderView } from '../types';
import { recipientSummary } from '../lib/format';

interface RecipientSectionProps {
    recipient: PaymentOrderView['recipient'];
}

const RecipientSection: React.FC<RecipientSectionProps> = ({ recipient }) => {
    return (
        <Col
            style={{
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderRadius: 16,
                padding: '20px',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
            }}
        >
            <Body3Bold style={{ color: colors.LAVEL_4 }}>받는 사람</Body3Bold>
            <Row
                style={{
                    marginTop: 10,
                    minHeight: 24,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Body3Regular style={{ color: colors.LAVEL_3, fontWeight: 600 }}>
                    {recipientSummary(recipient)}
                </Body3Regular>
            </Row>
        </Col>
    );
};

export default RecipientSection;
